import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';

import { Row, Col, Card, Tooltip, OverlayTrigger, Badge, Button, ListGroup, ListGroupItem } from 'react-bootstrap';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
// utils
import formatMoney from 'utils/formatMoney';
import trackingStatus from 'utils/validationTrackingStatus';
import { base64ToFile } from 'utils/base64ToFile';
// components
import CopyToClipboardIcon from 'components/CopyToClipboardIcon';
// reducers
import { setLabeIdForPickup } from '../../../../slices/shipping/shippingDataSlice';
import { setGeneralData } from '../../../../slices/generalData/generalData';

const CardShipping = ({ shipping, setShowActions, showActions, setIsReportModalOpen, setIsRefundModalOpen, setShippingToRefound }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [highlightButton, setHighlightButton] = useState(true);
  const status = shipping?.last_tracking_status;
  const isOpen = showActions === shipping?.shipping_label_id;

  // Validation status
  const validatedStatus = trackingStatus(status);
  // give status color
  const getStatusColor = (state) => {
    const statusColors = {
      'Etiqueta creada': 'muted',
      Retornado: 'danger',
      Recolectado: 'secondary',
      'Entrega actualizada': 'info',
      'En camino': 'primary',
      Entregado: 'success',
      Excepción: 'warning',
      'Proceso de Entrega': 'quaternary',
    };

    return statusColors[state] || 'muted';
  };

  const color = getStatusColor(validatedStatus);
  // console.log(`El color para "${status}" es:`, color);

  const downloadShippingLabel = (base64, fileName = 'guia.pdf') => {
    const file = base64ToFile(base64, fileName);
    const blobUrl = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = file.name;
    document.body.appendChild(a); // en algunos navegadores es necesario
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl); // liberar memoria
  };

  useEffect(() => {
    function handleClickOutside() {
      if (showActions !== null) {
        setShowActions(null);
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [showActions]);
  useEffect(() => {
    const timer = setTimeout(() => setHighlightButton(false), 7 * 24 * 60 * 60 * 1000); // 7 días
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <Card className="mb-2">
        <Row className="g-0 h-100 sh-xl-12 position-relative overflow-hiddenx">
          <Col xs="auto" className="position-relative ">
            <NavLink to={`/envios/historial/detalle/${shipping?.shipping_label_id}`}>
              <img src={shipping?.service_img} alt="service" className="card-img card-img-horizontal sw-11 h-100" />
            </NavLink>
          </Col>
          <Col className="py-4 py-xl-0 ps-5 pe-4 h-100">
            <Row className="g-0 h-100 align-content-center">
              <Col xs="11" xl="3" className="d-flex flex-column mb-xl-0 mb-3 pe-3 d-flex order-1 h-xl-100 justify-content-center bg-infox">
                <OverlayTrigger delay={{ show: 100, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Ver detalle de envío</Tooltip>}>
                  <NavLink className="anchor-effect-primary" to={`/envios/historial/detalle/${shipping?.shipping_label_id}`}>
                    {shipping.shipping_code?.replace(/_+/g, ' ')}
                  </NavLink>
                </OverlayTrigger>
                <div className="text-medium text-muted text-truncate">
                  ID:
                  {shipping?.shipping_label_id}
                  <CopyToClipboardIcon textToCopy={shipping?.shipping_label_id} />
                </div>
                <div className="text-small text-muted text-truncate">{shipping.address_to?.name}</div>
              </Col>
              <Col xs="6" xl="2" className="pe-1 mb-2 mb-xl-0 d-flex flex-column justify-content-center order-4 order-xl-2">
                <div className="text-muted text-small d-xl-none mb-1">Fecha / Hora </div>
                <div className="lh-1 text-alternate">{moment(shipping.creation_date).format('DD-MM-YY')}</div>
                <div className="lh-1 text-muted">{shipping?.creation_date.slice(11, 19)}</div>
              </Col>
              <Col xs="12" xl="2" className="bg-secondaryx mb-2 mb-xl-0 order-3 d-flex justify-content-end justify-content-xl-center align-items-center">
                <Badge bg={color} className="text-uppercase fw-bolder" style={{ fontSize: '12px' }}>
                  {validatedStatus}
                </Badge>
              </Col>
              <Col xs="6" xl="2" className="bg-infox pe-1 mb-2 mb-xl-0 d-flex flex-column justify-content-center align-items-end align-items-xl-center order-5">
                <div className="text-muted text-small d-xl-none mb-1">Costo</div>
                <div className={`text-center ${shipping.refunded ? 'text-success' : 'text-primary'}`}>
                  <span className="text-small text-muted">$</span>
                  {formatMoney(shipping.shipping_rates?.total)}
                  <div className={`text-small text-success ${shipping.refunded ? 'd-block' : 'd-none'}`}>Reembolsada</div>
                </div>
              </Col>
              <Col
                xs="12"
                xl="1"
                className="bg-secondaryx pe-1 mb-2 mb-xl-0 d-flex flex-column justify-content-center align-items-end align-items-xl-center order-5"
              >
                <div className="text-muted text-small d-xl-none mb-1">Peso cobrado</div>
                <div className="lh-1 text-alternate">
                  {shipping.parcel?.total_weight}
                  <span className="text-small text-muted"> kg</span>
                </div>
              </Col>
              <Col xs="1" className="mb-2 mb-xl-0 d-flex flex-column justify-content-xl-center align-items-end order-2 order-xl-last">
                {shipping?.shipping_label_id !== 'error' && (
                  <button
                    type="button"
                    className="btn btn-link ms-0 ms-sm-1 w-100 w-md-auto"
                    onClick={() => downloadShippingLabel(shipping?.label, `${shipping?.shipping_company}-${shipping?.shipping_label_id}.pdf`)}
                  >
                    <CsLineIcons icon="download" />
                  </button>
                )}
              </Col>
              <Col xs="12" xl="1" className="mb-2 mb-xl-0 d-flex justify-content-end align-items-center order-2 order-xl-last">
                {!isOpen && <CsLineIcons icon="chevron-right" size="18" className={`text-info me-2 ${highlightButton ? 'pulse-highlight' : ''}`} />}

                <div className="position-relative">
                  {!isOpen ? (
                    <OverlayTrigger delay={{ show: 100, hide: 0 }} placement="top" overlay={<Tooltip id="tooltip-top">Acciones</Tooltip>}>
                      <Button
                        variant="background"
                        // className={`btn-icon btn-icon-only hover-outline mb-1 position-relative ${highlightButton ? 'pulse-highlight' : ''}`}
                        className="btn-icon btn-icon-only hover-outline mb-1"
                        onClick={(e) => {
                          e.stopPropagation(); // 👈 evita que el click llegue al document
                          setShowActions(shipping.shipping_label_id);
                        }}
                      >
                        <CsLineIcons icon="more-horizontal" />
                      </Button>
                    </OverlayTrigger>
                  ) : (
                    <Button variant="background" className="btn-icon btn-icon-only hover-outline mb-1" onClick={() => setShowActions(null)}>
                      <CsLineIcons icon="more-horizontal" />
                    </Button>
                  )}
                  {showActions === shipping?.shipping_label_id && (
                    <AnimatePresence>
                      <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                        style={{
                          position: 'absolute',
                          zIndex: 1000,
                          top: '35px',
                          left: '-120px',
                          width: '150px',
                          overflowY: 'scroll',
                          cursor: 'pointer',
                          fontFamily: 'Montserrat',
                          borderRadius: '15px',
                          boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                        }}
                      >
                        <ListGroup>
                          <ListGroupItem
                            className="p-2 ps-3 rounded-0 list-group-item-hover"
                            onClick={() => {
                              setShowActions(null);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <CsLineIcons icon="support" size="16" className="text-primary" />
                              <button
                                type="button"
                                className="btn btn-link p-0 sh-3 text-body"
                                onClick={() => {
                                  dispatch(setGeneralData({ data: shipping.shipping_label_id, point: 'shippingIdToReport' }));
                                  setIsReportModalOpen(true);
                                }}
                              >
                                <div className="ms-2">Reportar</div>
                              </button>
                            </div>
                          </ListGroupItem>
                          <ListGroupItem
                            className="p-2 ps-3 rounded-0 list-group-item-hover"
                            onClick={() => {
                              setShowActions(null);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <CsLineIcons icon="slash" size="16" className="text-primary" />
                              <button
                                type="button"
                                className="btn btn-link p-0 sh-3 text-body"
                                onClick={() => {
                                  dispatch(setGeneralData({ data: shipping.shipping_label_id, point: 'shippingIdToReport' }));
                                  setIsRefundModalOpen(true);
                                  setShippingToRefound(shipping);
                                }}
                              >
                                <div className="ms-2">Cancelar</div>
                              </button>
                            </div>
                          </ListGroupItem>
                          <ListGroupItem
                            className="p-2 ps-3 rounded-0 list-group-item-hover"
                            onClick={() => {
                              setShowActions(null);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <CsLineIcons icon="destination" size="16" className="text-primary" />
                              <button
                                type="button"
                                className="btn btn-link p-0 sh-3 text-body"
                                onClick={() => {
                                  history.push('/envios/recolectar/programar');
                                  dispatch(setLabeIdForPickup(shipping.shipping_label_id));
                                }}
                              >
                                <div className="ms-2">Recolectar</div>
                              </button>
                            </div>
                          </ListGroupItem>
                        </ListGroup>
                      </motion.div>
                    </AnimatePresence>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
};
export default CardShipping;
